// extracted by mini-css-extract-plugin
module.exports = {"btn":"modal_btn___CPFf","bar":"modal_bar__2w8ut","modalBody":"modal_modalBody__2CnA0","body_div":"modal_body_div__3MMxW"};